import { useCallback } from "react";

const useDueDateChange = ({ api, taskId, task, setTask }) => {
  return useCallback(
    async (event) => {
      const { value } = event.target;

      try {
        const isoDate = value
          ? new Date(`${value}T00:00:00`).toISOString()
          : null;
        await api.task.updateTask(taskId, {
          due_date: isoDate,
          version: task.version,
        });
        const updatedTask = await api.task.getTaskById(taskId);
        setTask(updatedTask);
      } catch (error) {
        console.error("Error updating task due date:", error);
      }
    },
    [api, taskId, task, setTask]
  );
};

export default useDueDateChange;
